import React from 'react';

import 'styles/SupportCard.scss';

const SupportCard = (props) => {
  const {
    contactEmail,
  } = props;

  return (
    <div className='Card SupportCard animated fadeIn'>
      <div className='Card__header'>
        <h2 className='Card__title'>
          Support och feedback
        </h2>

        <span className='Card__icon material-icons'>
          contact_support
        </span>
      </div>
      <div className='Card__body'>
        <a
          href={`mailto:${contactEmail}`}
        >
          {contactEmail}
        </a>
      </div>
    </div>
  );
};

export default SupportCard;



// WEBPACK FOOTER //
// ./src/components/SupportCard.jsx